export default __webpack_public_path__ + "static/media/NathanHoebeke.38d2058e.png";